"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var numberLookupMap_1 = __importDefault(require("./helpers/numberLookupMap"));
// function that takes a unicode vulgar or a fraction and returns a decimal
var toDecimal = function (value) {
    if (typeof value === 'number') {
        return value;
    }
    if (value === '' || value === undefined || value === null) {
        return 0;
    }
    var _a = value.split(' '), int = _a[0], fraction = _a[1];
    if (fraction === undefined || fraction === '') {
        return parseFloat(int);
    }
    var decimal = Object.keys(numberLookupMap_1.default).find(function (key) { return numberLookupMap_1.default[key].vulgar === fraction || numberLookupMap_1.default[key].fraction === fraction; }) || fraction;
    return parseFloat(int) + parseFloat(decimal);
};
exports.default = toDecimal;
